<template lang="pug">
.card
    .card-image
        figure.image.is-4by3
            img.rounded-corners(src="@/assets/images/tre-jones.jpg")
    .card-content
        .media
            .media-left
                figure.image.is-48x48
                    img(src="@/assets/symbols/1.circle.png")
            .media-content
                p.title.is-5.has-text-weight-medium AP Poll
                p.subtitle.is-6.has-text-weight-light Last updated 5/1/2020
</template>

<script>
export default {
  name: "Weather"
};
</script>
